import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router'

import { ReconciliationViewBanner } from '@features/bankTransactions/elements/ReconciliationViewBanner/ReconciliationViewBanner'
import { ReconciliationViewBannerPage } from '@features/bankTransactions/enums/reconciliationViewBannerPage'
import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'

const MODULE_NAME = 'reconciliation-view-banner'

class ReconciliationViewBannerWebComponent extends DOMModel {
  @byAttrVal accountId: string
  @byAttrVal organizationId: string
}

type ReconciliationViewBannerModuleProps = {
  accountId: string
  organizationId: string
}

const ReconciliationViewBannerModule = ({
  accountId,
  organizationId,
}: ReconciliationViewBannerModuleProps): ReactElement => {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <UserOrganizationContextProvider organizationId={organizationId}>
            <UserOrganizationSettingsContextProvider organizationId={organizationId}>
              <CurrentUserContextProvider>
                <ReconciliationViewBanner accountId={accountId} page={ReconciliationViewBannerPage.Reconciliation} />
              </CurrentUserContextProvider>
            </UserOrganizationSettingsContextProvider>
          </UserOrganizationContextProvider>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const ReconciliationViewBannerCustomElement = createCustomElement(
  ReconciliationViewBannerModule,
  ReconciliationViewBannerWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, ReconciliationViewBannerCustomElement)

export default ReconciliationViewBannerCustomElement
